import GtmEvent from 'Utils/GoogleTagManagerEvent';
import { getAppDesign } from 'Utils/mobile';

const DURATION_MAX = 1800; // 30 minutes
const STEP_STORAGE = 'TRACK_FULL_FUNNEL_LAST_EVENT_STEP';
const TIME_STORAGE = 'TRACK_FULL_FUNNEL_LAST_EVENT_TIME';

const getLastEventSend = () => {
  const step = localStorage.getItem(STEP_STORAGE) || '';
  const time = localStorage.getItem(TIME_STORAGE);
  return {
    step,
    time,
  };
};

const updateLastEventSend = (step, time) => {
  localStorage.setItem(STEP_STORAGE, step);
  localStorage.setItem(TIME_STORAGE, time);
};

const computeStepDuration = (step, currentTime) => {
  const lastEventSend = getLastEventSend();
  const { step: lastEventStepSend, time: lastEventTimeSendString } = lastEventSend;
  updateLastEventSend(step, currentTime);

  if (step === lastEventStepSend) return null;
  if (!lastEventTimeSendString) return 0;

  const lastEventTimeSend = new Date(lastEventTimeSendString);
  const durationInSeconds = (currentTime.getTime() - lastEventTimeSend.getTime()) / 1000;
  return durationInSeconds > DURATION_MAX ? DURATION_MAX : durationInSeconds;
};

const sendTrackFullFunnelGtmEvent = ({
  application,
  step,
  numberOfInstallments,
  loanAmount,
}) => {
  const currentTime = new Date();

  GtmEvent({
    application_id: application.application_process_id,
    current_time: currentTime.toUTCString(),
    duration: computeStepDuration(step, currentTime),
    environment: getAppDesign(),
    event: 'track_full_funnel',
    is_recurrent: application.recurrent,
    loanAmount,
    numberOfInstallments,
    step,
    user_id: application.customer_id,
  });
};

const saveTrackFullFunnelLoginTime = () => {
  updateLastEventSend('Login', new Date());
};

export {
  sendTrackFullFunnelGtmEvent,
  saveTrackFullFunnelLoginTime,
};
